const Notifications = { as: '/notifications', href: '/notifications' };
export default Notifications;
